import { Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

import { getFormattedLocalizedDateTimeWithSeconds } from '$shared/utils/date.utils';

import styles from './incident-detail-sidecar.module.scss';

export interface IncidentDetailHeaderProps {
  incidentCreatedAt?: number;
  notificationRuleName?: string;
}

export function IncidentDetailHeader({
  incidentCreatedAt,
  notificationRuleName,
}: IncidentDetailHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.incidentDetailSidecarHeader}>
      <div className={styles.incidentDetailSidecarIcon}>
        <Icon name="alarm-ringing" size={IconSizeClasses.XSmall} className="bg-white" />
      </div>
      <div className={styles.incidentDetailSidecarTitle}>
        <Dialog.Title className="m-bottom-xxs">
          {incidentCreatedAt &&
            getFormattedLocalizedDateTimeWithSeconds(incidentCreatedAt)}
        </Dialog.Title>
        <div>
          {t('incidents.triggeredBy')} {notificationRuleName}
        </div>
      </div>
    </div>
  );
}
